'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@achra/ui/button';
import { cn } from '@achra/ui/lib/utils';
import { Separator } from '@achra/ui/separator';
import { ChevronUp } from 'lucide-react';
import { motion } from 'motion/react';
import { useWalletsCard } from '@/modules/networks/hooks/use-wallets-card';
import { StripedCard, StripedCardAction, StripedCardContent, StripedCardHeader, StripedCardTitle } from '@/modules/shared/components/striped-card';
import { WalletsList } from './components/wallets-list/wallets-list';
import { WalletsTable } from './components/wallets-table/wallets-table';
import type { Wallet } from '../../wallets-section';
export interface WalletsCardProps {
  wallets: Wallet[];
  className?: string;
  title?: string;
}
function WalletsCard(t0) {
  const $ = _c(49);
  const {
    wallets,
    className,
    title: t1
  } = t0;
  const title = t1 === undefined ? "Wallets" : t1;
  let t2;
  if ($[0] !== wallets) {
    t2 = {
      wallets
    };
    $[0] = wallets;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    toogleWalletTable,
    usdsTotalBalance,
    skyTotalBalance,
    proccesedWallets,
    handleToogleWalletTable
  } = useWalletsCard(t2);
  let t3;
  if ($[2] !== className) {
    t3 = cn("w-full", className);
    $[2] = className;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = `${title}: ${wallets.length || 0}`;
  let t5;
  if ($[4] !== t4) {
    t5 = <StripedCardTitle className="text-sm/5.5 md:text-base/6">{t4}</StripedCardTitle>;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== usdsTotalBalance) {
    t6 = <span className="text-accent-foreground font-semibold">{usdsTotalBalance}</span>;
    $[6] = usdsTotalBalance;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <span className="text-accent-foreground/30 font-semibold">USDS</span>;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t6) {
    t8 = <div className="flex items-center gap-2">{t6}{t7}</div>;
    $[9] = t6;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Separator orientation="vertical" className="hidden h-5.5! md:block" />;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== skyTotalBalance) {
    t10 = <span className="text-accent-foreground font-semibold">{skyTotalBalance}</span>;
    $[12] = skyTotalBalance;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <span className="text-accent-foreground/30 font-semibold">SKY</span>;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] !== t10) {
    t12 = <div className="flex items-center gap-2">{t10}{t11}</div>;
    $[15] = t10;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] !== t12 || $[18] !== t8) {
    t13 = <div className="flex flex-col items-end gap-0 text-sm/5.5 md:flex-row md:items-center md:gap-2 xl:gap-3.5 xl:text-base/6">{t8}{t9}{t12}</div>;
    $[17] = t12;
    $[18] = t8;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] !== toogleWalletTable) {
    t14 = cn("transition-all duration-300 ease-out", {
      "rotate-180": toogleWalletTable
    });
    $[20] = toogleWalletTable;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <ChevronUp className="size-6 rotate-180" />;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  let t16;
  if ($[23] !== handleToogleWalletTable || $[24] !== t14) {
    t16 = <Button variant="icon" size="iconSm" className={t14} onClick={handleToogleWalletTable} aria-label="Toggle wallets table">{t15}</Button>;
    $[23] = handleToogleWalletTable;
    $[24] = t14;
    $[25] = t16;
  } else {
    t16 = $[25];
  }
  let t17;
  if ($[26] !== t13 || $[27] !== t16) {
    t17 = <StripedCardAction className="flex items-center justify-between gap-6 md:gap-8 lg:gap-10">{t13}{t16}</StripedCardAction>;
    $[26] = t13;
    $[27] = t16;
    $[28] = t17;
  } else {
    t17 = $[28];
  }
  let t18;
  if ($[29] !== t17 || $[30] !== t5) {
    t18 = <StripedCardHeader className="items-center px-4">{t5}{t17}</StripedCardHeader>;
    $[29] = t17;
    $[30] = t5;
    $[31] = t18;
  } else {
    t18 = $[31];
  }
  let t19;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = {
      opacity: 0,
      height: 0,
      marginBottom: 0
    };
    $[32] = t19;
  } else {
    t19 = $[32];
  }
  const t20 = toogleWalletTable ? 1 : 0;
  const t21 = toogleWalletTable ? "auto" : 0;
  const t22 = toogleWalletTable ? "calc(var(--spacing) * 2)" : 0;
  let t23;
  if ($[33] !== t20 || $[34] !== t21 || $[35] !== t22) {
    t23 = {
      opacity: t20,
      height: t21,
      margin: t22
    };
    $[33] = t20;
    $[34] = t21;
    $[35] = t22;
    $[36] = t23;
  } else {
    t23 = $[36];
  }
  let t24;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = {
      duration: 0.3,
      ease: "easeInOut",
      height: {
        duration: 0.3,
        ease: "easeInOut"
      },
      marginBottom: {
        duration: 0.3,
        ease: "easeInOut"
      }
    };
    $[37] = t24;
  } else {
    t24 = $[37];
  }
  let t25;
  let t26;
  if ($[38] !== proccesedWallets) {
    t25 = <WalletsTable wallets={proccesedWallets} className="hidden md:block" />;
    t26 = <WalletsList wallets={proccesedWallets} className="block md:hidden" />;
    $[38] = proccesedWallets;
    $[39] = t25;
    $[40] = t26;
  } else {
    t25 = $[39];
    t26 = $[40];
  }
  let t27;
  if ($[41] !== t23 || $[42] !== t25 || $[43] !== t26) {
    t27 = <StripedCardContent className="flex flex-col gap-2 p-0 text-sm leading-5.5 font-semibold"><motion.div initial={t19} animate={t23} transition={t24}>{t25}{t26}</motion.div></StripedCardContent>;
    $[41] = t23;
    $[42] = t25;
    $[43] = t26;
    $[44] = t27;
  } else {
    t27 = $[44];
  }
  let t28;
  if ($[45] !== t18 || $[46] !== t27 || $[47] !== t3) {
    t28 = <StripedCard className={t3}>{t18}{t27}</StripedCard>;
    $[45] = t18;
    $[46] = t27;
    $[47] = t3;
    $[48] = t28;
  } else {
    t28 = $[48];
  }
  return t28;
}
export { WalletsCard };